import alertIcon from '../assets/image/common/alert-triangle.png'
import transferSuccess from '../assets/image/common/success1.png'
import ip from '../assets/image/common/user-center/ip.svg'
import logout from '../assets/image/common/user-center/logout.svg'
import userIcon from '../assets/image/common/user.svg'

import closeImg from '../assets/image/common/close.png'
import videoPageImg from '../assets/image/common/video-page.png'

export const weight: PlatformConfig['font']['weight'] = {
  primary: 100,
  secondary: 200,
  tertiary: 300,
  quaternary: 400,
  quinary: 500,
  senary: 600,
  septenary: 700,
  regular: 400,
  medium: 500,
  bold: 700,
}

export const font: PlatformConfig['font'] = {
  family: 'Ark Sans SC, PingFang SC',
  weight,
}

export type BaseConfigSource = Partial<Omit<PlatformConfig, 'header' | 'colors'>> & {
  header: Partial<PlatformConfig['header']>
  colors: Partial<PlatformConfig['colors']>
}

/** 下跌颜色 */
const down = '#FF5064'
const middle = '#FF9800'
/** 上涨颜色 */
const up = '#2EBD85'

export const BaseConfig = {
  contentWidth: `1200px`,
  userCenter: {
    images: {
      ip,
      logout,
      transferSuccess,
    },
  },
  alertIcon,
  videoPageImg,
  closeImg,
  header: {
    userIcon,
  },
  font,
  spacing: (...args: number[]) => {
    return args.map((item) => `${item * 4}px`).join(' ')
  },
  colors: {
    down,
    middle,
    up,
    low: down,
    high: up,
    error: '#FC495C',
    warning: '#FF8A00',
    success: '#00D391',
    status: {
      error: '#E81B40',
      success: '#28BA97',
      ing: '#3C53FF',
    },
  } as Colors,
  headerHeight: 64,
  breakpoints: {
    mobile: '1200px',
    userMobile: '1460px',
  },
} as PlatformConfig
